import {
  faBookSparkles,
  faCommentsQuestion,
  faInfoCircle,
} from "@fortawesome/pro-duotone-svg-icons"; // Importing from Pro package
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Person } from "@microsoft/mgt-react";
import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Switch } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { AppBar, AppBarSection, AppBarSpacer } from "@progress/kendo-react-layout";
import { Popup } from "@progress/kendo-react-popup";
import { Popover, PopoverActionsBar } from "@progress/kendo-react-tooltip";
import axios from "axios";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveUserPreferencesDebounced } from "../../Common/Services/UserPreferencesService";
import {
  darkModeEnabled,
  isAdmin,
  isAuthenticated,
  newHomepageEnabled,
  selectedRole,
  userData,
  userPreferences,
} from "../../Common/Store/CommonSignals";
import { selectAllEnvVariables } from "../../Common/Store/EnvSlice";
import { showAtlasMenu } from "../../Entry/Manage/EditEntrySignals";
import LearningGallery from "../../LearningCenter/LearningGallery";
import { SearchBar } from "../../Pages/SearchBar";
import { addUserPermissions } from "../../User/UserSlice";
import { getPermissions } from "../../Utilities/AuthorizationUtil";
import getLatestSuccessfulRelease from "../../Utilities/FetchAzureDevOps";
import "./AppBar.css";

const AtlasAppBar = () => {
  const [show, setShow] = React.useState(false);
  const [anchor, setAnchor] = useState(null);
  const [deploymentData, setDeploymentData] = useState(null);
  const [showWindow, setShowWindow] = useState(false);
  const envVariables = useSelector(selectAllEnvVariables);
  const userEmail = userData.value?.userEmail;
  const userRoles = userData.value?.roles;
  const dispatch = useDispatch();
  const [popupVisible, setPopupVisible] = useState(false);
  const avatarRef = useRef(null);

  const togglePopup = () => {
    setPopupVisible(!popupVisible);
  };

  const handleLogout = async (event) => {
    event.stopPropagation();

    const storedToken = localStorage.getItem("atlas.sessionToken");

    try {
      await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/auth/saml/logout`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
          },
        }
      );
    } catch (error) {
      console.error("Logout error:", error);
    }

    localStorage.removeItem("atlas.sessionToken");
    isAuthenticated.value = false;
    userData.value = null;
  };

  const closePopup = () => {
    setPopupVisible(false);
    setShow(false);
  };

  const handleBugClick = () => {
    const newWindow = window.open();
    newWindow.opener = null;
    newWindow.location =
      "https://cmpprod.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=906528a10a0a0bf000a85bc20dfb6541&sysparm_link_parent=e15706fc0a0a0aa7007fc21e1ab70c2f&sysparm_catalog=e0d08b13c3330100c8b837659bba8fb4&sysparm_catalog_view=catalog_default";
  };

  const handleLearnClick = () => {
    setShowWindow(true);
  };

  const fetchDeploymentData = async () => {
    const branchName = envVariables.REACT_APP_AZDEVOPS_BRANCH;
    const data = await getLatestSuccessfulRelease(branchName, envVariables);
    console.log(data);
    setDeploymentData(data);
  };

  const ShowAbout = (event) => {
    fetchDeploymentData();
    setShow(true);
    setAnchor(event.currentTarget);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const renderAbout = () => {
    return (
      <Popover
        anchor={anchor}
        show={show}
        onClose={() => setShow(false)}
        position="bottom"
        collision={{
          vertical: "none",
          horizontal: "fit",
        }}
        title={"About Atlas"}
      >
        <div className="about-popover">
          <h4>
            Version: <br />
            {deploymentData ? deploymentData.releaseNumber : "Loading..."}
          </h4>
          <h4>
            Environment: <br />
            {deploymentData ? deploymentData.branchName : "Loading..."}
          </h4>
          <h4>
            Last Update: <br />
            {deploymentData ? formatDate(deploymentData.lastDeploymentDate) : "Loading..."}
          </h4>
        </div>

        <PopoverActionsBar>
          <div
            style={{
              display: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              onClick={closePopup}
              size={"small"}
              style={{ justifyItems: "center" }}
            >
              Close
            </Button>
          </div>
        </PopoverActionsBar>
      </Popover>
    );
  };

  const handleRoleChange = (e) => {
    const ADGroupIds = {
      ATLAS_Admin: "8007faf5-493c-4179-aa8e-017a49391c6c",
      ATLAS_Poweruser: "0497a4d4-a91f-4616-8bd6-b21eb7b64caf",
    };
    selectedRole.value = e.target.value;
    const permissions = getPermissions([{ id: ADGroupIds[e.target.value] }], userRoles);
    dispatch(addUserPermissions(permissions));
  };

  return (
    <>
      {showAtlasMenu.value && (
        <>
          <AppBar className="appbar-gradient">
            <AppBarSpacer
              style={{
                width: "5rem",
              }}
            />

            <AppBarSection>
              <div className="atlas-title">Atlas</div>
              {envVariables.REACT_APP_AZDEVOPS_BRANCH !== "master" && (
                <span
                  className="current-environment"
                  style={{ display: "inline-block" }}
                >
                  {" " + String(envVariables.REACT_APP_AZDEVOPS_BRANCH).toUpperCase()}
                </span>
              )}
            </AppBarSection>
            <AppBarSection>
              <SearchBar />
            </AppBarSection>
            <AppBarSpacer />

            <AppBarSection>
              <div style={{ padding: "2px", marginTop: "2px" }}>
                <button
                  onClick={handleLearnClick}
                  className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                    width: "25px",
                    height: "25px",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faBookSparkles}
                    size="xl"
                    style={{
                      "--fa-primary-color": "#ffffff",
                      "--fa-secondary-color": "#222861",
                    }}
                  />
                </button>

                <button
                  onClick={handleBugClick}
                  className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
                  style={{ border: "none", width: "25px", height: "25px" }}
                >
                  <FontAwesomeIcon
                    icon={faCommentsQuestion}
                    size="xl"
                    style={{
                      "--fa-primary-color": "#ffffff",
                      "--fa-secondary-color": "#001f3e",
                    }}
                  />
                </button>

                <button
                  onClick={ShowAbout}
                  className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
                  style={{ border: "none", width: "25px", height: "25px" }}
                >
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    size="xl"
                    style={{
                      "--fa-primary-color": "#ffffff",
                      "--fa-secondary-color": "#001f3e",
                    }}
                  />
                </button>

                <div onMouseDown={(event) => event.stopPropagation()}>
                  <Popup
                    anchor={avatarRef.current}
                    anchorAlign={{ horizontal: "right", vertical: "bottom" }}
                    popupAlign={{ horizontal: "right", vertical: "top" }}
                    show={show}
                    onClose={closePopup}
                    style={{ width: 300 }}
                  >
                    {renderAbout()}
                  </Popup>
                </div>
              </div>
            </AppBarSection>

            <AppBarSection>
              <span className="k-appbar-separator" />
            </AppBarSection>

            <AppBarSection style={{ width: "40px" }}>
              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  overflow: "hidden",
                }}
              >
                <Person
                  ref={avatarRef}
                  personQuery={userData.value?.userEmail}
                  onClick={togglePopup}
                />
              </div>
            </AppBarSection>
          </AppBar>
          {showWindow && (
            <LearningGallery
              showWindow={showWindow}
              onClose={() => setShowWindow(false)}
            />
          )}
          {popupVisible && (
            <Popup
              anchor={avatarRef.current}
              anchorAlign={{ horizontal: "right", vertical: "bottom" }}
              popupAlign={{ horizontal: "right", vertical: "top" }}
              show={popupVisible}
              onClose={closePopup}
              style={{ width: 300 }}
            >
              <div style={{ borderRadius: "25px", padding: "15px" }}>
                <h3>User Profile</h3>
                <p>Name: {userData.value?.userEmail.split("@")[0]}</p>
                <p>Email: {userEmail}</p>

                <div style={{ display: "flex", alignItems: "center", paddingBottom: "14px" }}>
                  <span style={{ marginRight: "10px" }}>Enable Dark Mode</span>
                  <Switch
                    checked={darkModeEnabled.value}
                    onChange={(e) => {
                      darkModeEnabled.value = e.value;
                      saveUserPreferencesDebounced(
                        userPreferences.value?.id,
                        userEmail,
                        userPreferences.value?.favoriteTemplatesIds,
                        userPreferences.value?.favoriteDatasetsIds,
                        newHomepageEnabled.value,
                        e.value
                      );
                    }}
                    size="medium"
                    offLabel="I"
                    onLabel="O"
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center", paddingBottom: "14px" }}>
                  <span style={{ marginRight: "10px" }}>Enable New Homepage</span>
                  <Switch
                    checked={newHomepageEnabled.value}
                    onChange={(e) => {
                      newHomepageEnabled.value = e.value;
                      saveUserPreferencesDebounced(
                        userPreferences.value?.id,
                        userEmail,
                        userPreferences.value?.favoriteTemplatesIds,
                        userPreferences.value?.favoriteDatasetsIds,
                        e.value,
                        darkModeEnabled.value
                      );
                    }}
                    size="medium"
                    offLabel="I"
                    onLabel="O"
                  />
                </div>

                {isAdmin.value && (
                  <div className="k-mb-5">
                    <Label>User Role:</Label>
                    <DropDownList
                      data={["ATLAS_Admin", "ATLAS_Poweruser"]}
                      onChange={(e) => handleRoleChange(e)}
                      value={selectedRole.value}
                    />
                  </div>
                )}
                <button onClick={(event) => handleLogout(event)}>Logout</button>
              </div>
            </Popup>
          )}
        </>
      )}
    </>
  );
};

export default AtlasAppBar;
